export class ListaLogRequest {
  public idLog: number | null;

  public listaIdEmpresa: number[] | null;

  public tipo: string | null;

  public textoBusca: string | null;

  public paginaAtual: number;
}
